<template>
  <div>
    <div class="blocks">
      <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="col-8 d-flex align-items-center">
          <h1 class="pr-3">Leads</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control" type="text" v-model="q" @keydown="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
        <div class="col-2">
          <load-filter-dropdown
            @filterSelected="loadFilters"
            @filterTemplatesInitialized="setFilterTemplatesInitialized"
            :route="$route.name"
          />
        </div>
        <div class="col-2 text-right d-none d-md-flex d-lg-flex d-xl-flex">
          <button class="btn btn-primary" @click="showCreateSidebar = !showCreateSidebar">
            ADD LEAD
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center d-md-none">
        <div class="number-of-jobs" v-if="meta">
          {{ meta.to }} of {{ meta.total }} <span class="us-hidden">Leads</span>
        </div>
        <div>
          <div class="col-12 text-right pr-0 d-flex align-items-center mobile-lead-menu">
            <button class="btn btn-primary" @click="showCreateSidebar = !showCreateSidebar">
              ADD LEAD
            </button>
            <button class="btn btn-secondary expand-all" @click="toggleAllLeads">
              <i :class="[leads && expandedAll ? 'fa fa-compress' : 'fa fa-expand']" />
            </button>
          </div>
        </div>
      </div>
      <div class="row d-none d-md-flex d-lg-flex d-xl-flex">
        <div class="col-11 filters-field">
          <span>Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.company.length && companies">
              <span v-for="company in filters.company" :key="company" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('company', company)" />
                Company: {{ companies.find(el => el.id === company).name }}</span>
            </span>
            <span v-if="filters.clusterUser.length && salesFilter.length">
              <span v-for="clusterUser in filters.clusterUser" :key="clusterUser" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('clusterUser', clusterUser)" />
                Sales: {{ salesFilter.find(el => el.id === clusterUser).full_name }}</span>
            </span>
            <span v-if="filters.moveSize" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('moveSize')" />
              Move Size: {{ moveSizes.find(el => el.id === filters.moveSize).name }}</span>
            <span v-if="filters.move_date" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('move_date')" />
              Move Date: {{ filters.move_date }}</span>
            <span v-if="filters.created_at" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('created_at')" />
              Created At: {{ filters.created_at }}</span>
            <span v-if="filters.status" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('status')" />
              Status: {{ leadStatuses.find(el => el.id === filters.status).name }}</span>
            <span v-if="filters.source" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('source')" />
              Source: {{ sources.find(el => el.id === filters.source).name }}</span>
            <span v-if="filters.closed" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('closed')" />
              Show Closed: {{ filters.closed === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.feeChange" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('feeChange')" />
              Fee Changes Required: {{ filters.feeChange === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.hasHeavyItems" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('hasHeavyItems')" />
              Has heavy items: {{ filters.hasHeavyItems === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.offers_sent" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('offers_sent')" />
              Offers Sent: {{ filters.offers_sent === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.tags.length && tags">
              <span v-for="item in filters.tags" :key="item" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('tags', item)" />
                Tag: {{ tags.find(el => el.id === item).name }} </span>
            </span>
            <span v-if="filters.withoutFollowup.length && leadFollowUpTypes">
              <span v-for="item in filters.withoutFollowup" :key="item" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('withoutFollowup', item)" />
                Without followup: {{ leadFollowUpTypes.find(el => el.id === item).name }} </span>
            </span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
        <div class="col-1 d-flex justify-content-end">
          <div class="dropdown">
            <button class="btn btn-secondary sort-button sort-button-selected" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
            >
              <i v-if="selectedKey.length" class="fa pr-2" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
              <span v-if="selectedKey === 'created_at'">
                Created at
              </span>
              <span v-else-if="selectedKey === 'move_date'">
                Move date
              </span>
              <span v-else>
                Sort by
              </span>
              <i class="fa fa-caret-down caret" />
            </button>
            <div class="dropdown-menu sort-dropdown dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('created_at')">
                <span :class="[selectedKey === 'created_at' ? 'selected' : '']">
                  Created date
                </span>
                <span>
                  <i v-if="selectedKey === 'created_at'" class="fa" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                </span>
              </button>
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('move_date')">
                <span :class="[selectedKey === 'move_date' ? 'selected' : '']">
                  Move date
                </span>
                <span>
                  <i v-if="selectedKey === 'move_date'" class="fa" :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']" />
                </span>
              </button>
            </div>
          </div>
          <button class="btn btn-secondary expand-all" @click="toggleAllLeads">
            <i :class="[leads && expandedAll ? 'fa fa-compress' : 'fa fa-expand']" />
          </button>
        </div>
      </div>
    </div>
    <template v-if="!leads">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks">
        <LeadsBlock
          v-for="(lead, index) in leads" :key="index"
          :lead.sync="lead"
          :q.sync="q"
          :expanded="expanded"
          @expanded="toggleLead"
          @setFiltersSaved="callSetFiltersSaved"
        />
      </div>

      <div class="row blocks">
        <div class="col-sm-6 mb-1 pl-0 text-black-50"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div class="filters-side-modal flex flex-column justify-content-between">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Company</label>
                      <key-multiselect v-model="filters.company"
                                       :options="companies"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'company-select'"
                                       :placeholder="'Select Company'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move Size</label>
                      <simple-select v-model="filters.moveSize"
                                     :input-id="'move-size-select'"
                                     :options="moveSizes"
                                     placeholder="Select Move Size"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.move_date"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onMoveDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearMoveDateAndSearch"
                            v-if="filters.move_date"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Created At</label>
                      <flat-pickr v-model="filters.created_at"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Created Date"
                                  name="date"
                                  @on-close="onCreatedDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearCreatedDateAndSearch"
                            v-if="filters.created_at"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12" v-if="salesFilter && salesFilter.length">
                    <div class="select-wrap">
                      <label>Sales Rep.</label>
                      <key-multiselect v-model="filters.clusterUser"
                                       :options="salesFilter"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'sales-select'"
                                       :placeholder="'Select Sales'"
                                       :preserve-search="false"
                                       label="full_name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.full_name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Status</label>
                      <simple-select v-model="filters.status"
                                     :options="leadStatuses"
                                     :input-id="'status-select'"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Source</label>
                      <simple-select v-model="filters.source"
                                     :options="sources"
                                     :input-id="'source-select'"
                                     placeholder="Select Source"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Show closed</label>
                      <simple-select v-model="filters.closed"
                                     :options="booleanOptions"
                                     :input-id="'closed-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Fee Changes Required</label>
                      <simple-select v-model="filters.feeChange"
                                     :options="booleanOptions"
                                     :input-id="'heavy-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has heavy tems</label>
                      <simple-select v-model="filters.hasHeavyItems"
                                     :options="booleanOptions"
                                     :input-id="'heavy-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Offers sent</label>
                      <simple-select v-model="filters.offers_sent"
                                     :options="booleanOptions"
                                     :input-id="'offers-sent-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div v-if="$_can('tags.show')" class="col-12">
                    <div class="select-wrap">
                      <label>Tags</label>
                      <key-multiselect
                        v-model="filters.tags"
                        :options="tags"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                        track-by="id"
                        @input="search"
                        label="name"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag p-0 bg-transparent">
                            <span>
                              <tag-color
                                :color="props.option.color.name"
                                :name="props.option.name"
                              />
                            </span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="leadFollowUpTypes.length">
                    <div class="select-wrap">
                      <label>Without followup</label>
                      <key-multiselect v-model="filters.withoutFollowup"
                                       :options="leadFollowUpTypes"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'follow-up-type-select'"
                                       :placeholder="'Select Type'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary text-white w-100" @click="saveFiltersModal = true"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Save filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Create Lead -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar" @click.self="hideCreateSidebar">
        <leads-create class="sidebar-right"
                      @cancel="hideCreateSidebar"
                      @leads-search="checkDuplicateLeads"
                      :searching-duplicate-leads="searchingDuplicateLeads"
                      @leads-clear="clearDuplicateLeads"
        />
      </div>
    </transition>

    <!-- Duplicate lead -->
    <transition name="slide-fade">
      <div class="duplicate-lead-wrap" v-if="duplicateLeads.length">
        <h3>Existing leads for the same customer have been found.</h3>
        <div class="duplicate-lead-box-overflow">
          <div class="duplicate-lead-box"
               :class="{'lead-can-access': lead.can_access === true}"
               v-for="lead in duplicateLeads"
               :key="lead.id"
          >
            <router-link :to="`/leads/edit/${lead.id}?q=${lead.ref_id}`"
                         :class="[lead.can_access === true ? 'pointer' : 'pointer-events-none']"
            >
              <div class="col-md-4 px-0 mb-0">
                <span class="refId">{{ lead.ref_id }}</span>
              </div>
              <div class="col-md-6 px-0 mb-0">
                <span class="name">{{ lead.customer }}</span>
              </div>
              <div class="col-md-2 px-0 mb-0 text-right">
                <span class="mod-icon-arrow" />
              </div>
              <div class="col-md-12 px-0 mb-0 pt-1">
                <div class="input-wrap">
                  <label>Assigned to</label>
                  <p>{{ lead.cluster_user ? lead.cluster_user : '-' }}</p>
                </div>
              </div>
              <div class="col-md-8 px-0 mb-0 pt-2">
                <div class="input-wrap">
                  <label>Company</label>
                  <p>{{ lead.company }}</p>
                </div>
              </div>
              <div class="col-md-4 px-0 mb-0 pt-2 text-right">
                <template v-if="lead.status">
                  <span v-if="lead.status_id === 1 || lead.status_id === 7"
                        :class="'btn-status btn-active'"
                  >{{ lead.status.name }}</span>
                  <span v-if="lead.status_id === 2"
                        :class="'btn-status btn-booked'"
                  >{{ lead.status.name }}</span>
                  <span v-if="lead.status_id === 3 || lead.status_id === 6"
                        :class="'btn-status btn-closed'"
                  >{{ lead.status.name }}</span>
                  <span v-if="lead.status_id === 4 || lead.status_id === 8"
                        :class="'btn-status btn-ncover'"
                  >{{ lead.status.name }}</span>
                  <span v-if="lead.status_id === 5"
                        :class="'btn-status btn-rtbook'"
                  >{{ lead.status.name }}</span>
                </template>
              </div>
            </router-link>
          </div>
          <error-field :errors="errors" field="leads" />
        </div>
      </div>
    </transition>

    <!-- Save filters modal -->
    <SaveFiltersModal
      v-if="saveFiltersModal"
      @close="saveFiltersModal = false"
      :filters="filters"
      :route="$route.path"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import TagColor from '../settings/Tags/TagColor';
import Pagination from '../Pagination';
import LeadsCreate from './LeadsCreate';
import LeadsBlock from './LeadsBlock';
import 'flatpickr/dist/flatpickr.css';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import SaveFiltersModal from '../SaveFiltersModal.vue';
import LoadFilterDropdown from '../LoadFilterDropdown.vue';

export default {
  name: 'Leads',
  components: {
    LoadFilterDropdown,
    SaveFiltersModal,
    Pagination,
    LeadsCreate,
    LeadsBlock,
    flatPickr,
    ErrorField,
    TagColor,
  },
  data: () => ({
    booleanOptions: [
      {
        id: 'true',
        name: 'Yes',
      },
      {
        id: 0,
        name: 'No',
      },
    ],
    can_access: '',
    closeDuplicate: false,
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
    duplicateLeads: [],
    errors: new Errors(),
    expanded: [],
    expandedAll: false,
    filters: {
      closed: '',
      clusterUser: [],
      company: [],
      createdDateEnd: '',
      createdDateStart: '',
      created_at: '',
      feeChange: '',
      hasHeavyItems: '',
      moveDateEnd: '',
      moveDateStart: '',
      moveSize: '',
      move_date: '',
      offers_sent: '',
      sortKey: '',
      sortOrders: '',
      source: '',
      status: '',
      tags: [],
      withoutFollowup: [],
    },
    filterTemplatesInitialized: false,
    hasDefaultFilterTemplate: true,
    loading: true,
    page: 1,
    prevRouteName: '',
    q: '',
    saveFiltersModal: false,
    searchingDuplicateLeads: 0,
    selectedKey: '',
    showCreateSidebar: false,
    showFilters: false,
    tags: [],
    timer: null,
  }),
  computed: {
    ...mapState({
      clusterUsers: state => state.clusterUsers.clusterUsers.data,
      companies: state => state.companies.companies.data,
      filtersLoaded: state => state.guard.filtersLoaded,
      filtersSaved: state => state.filters.filtersSaved,
      leadFollowUpTypes: state => state.values.leadFollowUpTypes,
      leadStatuses: state => state.values.leadStatuses,
      leads: state => state.leads.leads.data,
      meta: state => state.leads.leads.meta,
      moveSizes: state => state.values.moveSizes,
      salesFilter: state => state.clusterUsers.salesFilter,
      sources: state => state.values.sources,
    }),
    ...mapGetters(['getLeadsFiltered', 'getFiltersSaved']),
    ascOrDesc() {
      return this.filters.sortOrders === 'asc' ? 'asc' : 'desc';
    },
    clearFiltersButtonShouldBeDisabled() {
      return (
        !this.filters.company.length &&
        !this.filters.moveSize &&
        !this.filters.move_date &&
        !this.filters.created_at &&
        !this.filters.clusterUser.length &&
        !this.filters.feeChange &&
        !this.filters.hasHeavyItems &&
        !this.filters.status &&
        !this.filters.source &&
        !this.filters.closed &&
        !this.filters.offers_sent &&
        !this.filters.tags &&
        !this.filters.withoutFollowup.length
      );
    },
  },
  watch: {
    filterTemplatesInitialized() {
      if (!this.hasDefaultFilterTemplate) {
        if (this.filtersSaved && this.filtersSaved.previousPage === 'LeadsEdit') {
          this.filters = { ...this.filtersSaved };
          this.page = this.filtersSaved.page;
        } else if (Object.keys(this.$route.query).length !== 0) {
          this.setFilters(this.$route.query);
        }
      }
      this.filter();
    },
    leads() {
      if (this.expandedAll) {
        this.leads.forEach(lead => {
          this.expanded.push(lead.id);
        });
      } else {
        this.expanded = [];
      }
    },
  },
  mounted() {
    this.getTags();
    this.getLeadFollowUpTypes();
    this.getLeadStatuses();
  },
  methods: {
    ...mapActions(['getLeads', 'getLeadFollowUpTypes', 'getLeadStatuses']),
    ...mapMutations(['setLeads', 'setFiltersSaved']),
    loadFilters(filtersData) {
      this.filters = Object.assign(filtersData);
      this.filter();
    },
    setFilterTemplatesInitialized(hasDefault) {
      this.hasDefaultFilterTemplate = hasDefault;
      this.filterTemplatesInitialized = true;
    },
    setFilters(query) {
      this.filters = Object.assign(
        {
          company: query.company_id ? query.company_id.split(',').map(i => Number(i)) : [],
          moveSize: query.move_size_id ? parseInt(query.move_size_id, 10) : '',
          moveDateStart: query.date_from.toString(),
          moveDateEnd: query.date_to.toString(),
          move_date:
            query.date_from && query.date_to
              ? `${query.date_from.toString()} to ${query.date_to.toString()}`
              : '',
          createdDateStart: query.created_from.toString(),
          createdDateEnd: query.created_to.toString(),
          created_at:
            query.created_from && query.created_to
              ? `${query.created_from.toString()} to ${query.created_from.toString()}`
              : '',
          clusterUser: query.cluster_user_id
            ? query.cluster_user_id.split(',').map(i => Number(i))
            : [],
          feeChange: query.fee_change,
          hasHeavyItems: query.has_heavy_items,
          status: query.status_id ? parseInt(query.status_id, 10) : '',
          source: query.source_id ? parseInt(query.source_id, 10) : '',
          closed: query.closed,
          tags: query.tag_id ? query.tag_id.split(',').map(i => Number(i)) : [],
          offers_sent: query.offers_sent,
          q: encodeURIComponent(query.q),
          sortKey: query.sort,
          sortOrders: query.order,
          tag: query.tag_id ? query.tag_id.split(',').map(i => Number(i)) : [],
          withoutFollowup: query.without_followup_id
            ? query.without_followup_id.split(',').map(i => Number(i))
            : [],
        },
        {},
      );
      this.page = query.page;
      this.selectedKey = this.filters.sortKey;
    },
    hideCreateSidebar() {
      this.duplicateLeads = [];
      this.showCreateSidebar = false;
    },
    checkDuplicateLeads(lead) {
      let url = `leads/duplicates?company_id=${lead.company_id}`;
      if (lead.phone) {
        url += `&phone=${encodeURIComponent(lead.phone)}`;
      }
      if (lead.email) {
        url += `&email=${encodeURIComponent(lead.email)}`;
      }
      axios
        .get(`${url}`)
        .then(result => {
          if (this.showCreateSidebar) {
            this.duplicateLeads = result.data.data;
          }
        })
        .catch(err => {
          this.duplicateLeads = [];
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.searchingDuplicateLeads = this.duplicateLeads.length;
        });
    },
    callSetFiltersSaved() {
      this.setFiltersSaved({ ...this.filters, previousPage: 'LeadsEdit', page: this.page });
    },
    clearDuplicateLeads() {
      this.duplicateLeads = [];
    },
    changePage(pageNum) {
      this.setLeads({});
      this.page = pageNum;
      this.filter();
    },
    searchText(e) {
      // eslint-disable-next-line no-unused-expressions
      e.key;
      this.page = 1;
      const vm = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        vm.filter();
      }, 500);
      // if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
      //   const vm = this;
      //   clearTimeout(this.timer);
      //   this.timer = setTimeout(() => {
      //     vm.filter();
      //   }, 500);
      // }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.setLeads({});
      const query =
        `page=${this.page}&company_id=${this.filters.company}` +
        `&move_size_id=${this.filters.moveSize}&date_from=${this.filters.moveDateStart}` +
        `&date_to=${this.filters.moveDateEnd}&created_from=${
          this.filters.createdDateStart
        }&created_to=${this.filters.createdDateEnd}` +
        `&cluster_user_id=${this.filters.clusterUser}&fee_change=${
          this.filters.feeChange
        }&has_heavy_items=${this.filters.hasHeavyItems}&status_id=${
          this.filters.status
        }&source_id=${this.filters.source}&closed=${this.filters.closed}&offers_sent=${
          this.filters.offers_sent
        }&tag_id=${this.filters.tags}&without_followup_id=${
          this.filters.withoutFollowup
        }&q=${encodeURIComponent(this.q)}&sort=${this.filters.sortKey}&order=${
          this.filters.sortOrders
        }`;
      this.getLeadsFiltered(query);
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/leads?${query}`);
      } else {
        this.$router.push(`/leads`);
      }
    },
    getTags() {
      axios
        .get('/companies/tags/list?paginated=false')
        .then(res => {
          this.tags = res.data.data;
        })
        .catch(() => {});
    },
    clearFilters() {
      this.filters = Object.assign(
        {
          company: [],
          clusterUser: [],
          moveSize: '',
          move_date: '',
          moveDateStart: '',
          moveDateEnd: '',
          created_at: '',
          createdDateStart: '',
          createdDateEnd: '',
          feeChange: '',
          hasHeavyItems: '',
          status: '',
          source: '',
          tags: [],
          withoutFollowup: [],
          offers_sent: '',
          sortKey: '',
          sortOrders: '',
        },
        {},
      );
      this.filter();
      this.showFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearMoveDateAndSearch() {
      this.filters.move_date = '';
      this.filters.moveDateStart = '';
      this.filters.moveDateEnd = '';
      this.page = 1;
      this.filter();
    },
    clearCreatedDateAndSearch() {
      this.filters.created_at = '';
      this.filters.createdDateStart = '';
      this.filters.createdDateEnd = '';
      this.page = 1;
      this.filter();
    },
    sortBy(key) {
      this.selectedKey = key;
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrders', this.filters.sortOrders === 'desc' ? 'asc' : 'desc');
      this.filter();
    },
    onMoveDateChange(selectedDates) {
      this.filters.moveDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.moveDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    onCreatedDateChange(selectedDates) {
      this.filters.createdDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.createdDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      if (model === 'move_date') {
        this.filters.moveDateStart = '';
        this.filters.moveDateEnd = '';
      }
      if (model === 'created_at') {
        this.filters.createdDateStart = '';
        this.filters.createdDateEnd = '';
      }
      this.search();
    },
    toggleLead(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllLeads() {
      if (!this.expanded.length) {
        this.leads.forEach(claim => {
          this.expanded.push(claim.id);
          this.expandedAll = true;
        });
      } else {
        this.expanded = [];
        this.expandedAll = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/leads/Leads.vue